import { render } from "./OverallFeedback.vue?vue&type=template&id=843a8f60&scoped=true"
import script from "./OverallFeedback.vue?vue&type=script&lang=js"
export * from "./OverallFeedback.vue?vue&type=script&lang=js"

import "./OverallFeedback.vue?vue&type=style&index=0&id=843a8f60&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-843a8f60"]])

export default __exports__